export enum ESurveyQuestionType {
  Boolean = 'boolean',
  Date = 'date',
  Radio = 'radio',
  Textarea = 'textarea',
}

export enum ESurveyType {
  Intervention = 'intervention',
  ServiceRequest = 'service_request',
}

export enum ESurveySource {
  Backoffice = 'backoffice',
  Connect = 'connect',
}

export enum ESurveyLanguage {
  FR = 'fr',
  NL = 'nl',
}

export enum ESurveyEntryPoint {
  Satisfied = 'satisfied',
  Unsatisfied = 'unsatisfied',
  VerySatisfied = 'very_satisfied',
  VeryUnsatisfied = 'very_unsatisfied',
}

export enum ESurveyGroup {
  Completion = 'completion',
  Feedback = 'feedback',
  Intervention = 'intervention',
  Rescheduling = 'rescheduling',
  Satisfaction = 'satisfaction',
}
